import {useMemo} from "react";
import {useSelector} from "react-redux";
import {useLocation} from "react-router";

import {rpAppLink} from "@pg-mono/rp-routes";

import {IRPStore} from "../../app/rp_reducer";

const LOCATION_PARAM = "lokalizacja";

export const useVendorBreadcrumbs = () => {
    const location = useLocation();
    const vendorList = useSelector((store: IRPStore) => store.vendor.list);
    const vendor = useSelector((store: IRPStore) => store.vendor.detail.vendor);
    const cities = useSelector((store: IRPStore) => store.vendor.detail.cities ?? []);
    const region = vendorList.region?.length === 1 ? vendorList.region[0] : undefined;

    const regionsList = [
        region?.stats?.region_type_voivodeship,
        region?.stats?.region_type_county,
        region?.stats?.region_type_city,
        region?.stats?.region_type_district,
        region?.stats?.region_type_housing_estate,
        region?.stats?.region_type_town
    ].filter(Boolean);

    const locationSlug = useMemo(() => {
        const params = new URLSearchParams(location.search);

        return params.get(LOCATION_PARAM);
    }, [location.search]);

    const cityFromParam = useMemo(() => {
        if (!locationSlug || !cities.length) {
            return null;
        }

        return cities.find((c) => c.slug === locationSlug) ?? null;
    }, [cities, locationSlug]);

    const baseCrumbs = [
        {key: "Deweloperzy", name: "Deweloperzy", position: "2", url: rpAppLink.vendor.list()},
        ...regionsList.map((region, index) => ({
            key: region?.name ?? index,
            name: region?.name ?? "",
            position: (index + 3).toString(),
            url: rpAppLink.vendor.listFriendly({friendlySlug: region?.slug ?? ""})
        })),
        ...(vendor
            ? [
                  {
                      key: vendor.name,
                      name: vendor.name,
                      position: "3",
                      url: rpAppLink.vendor.detail.base({vendorSlug: vendor.slug, vendorId: vendor.id})
                  }
              ]
            : [])
    ];

    const currentPageUrl = `${location.pathname}${location.search ? location.search : ""}`;

    const locationCrumb =
        vendor && cityFromParam
            ? [
                  {
                      key: `lokalizacja-${cityFromParam.slug}`,
                      name: cityFromParam.name,
                      position: (baseCrumbs.length + 1).toString(),
                      url: currentPageUrl
                  }
              ]
            : [];

    return [...baseCrumbs, ...locationCrumb];
};
import {useMemo} from "react";
import {useSelector} from "react-redux";
import {useLocation} from "react-router";

import {rpAppLink} from "@pg-mono/rp-routes";

import {IRPStore} from "../../app/rp_reducer";

const LOCATION_PARAM = "lokalizacja";

export const useVendorBreadcrumbs = () => {
    const location = useLocation();
    const vendorList = useSelector((store: IRPStore) => store.vendor.list);
    const vendor = useSelector((store: IRPStore) => store.vendor.detail.vendor);
    const cities = useSelector((store: IRPStore) => store.vendor.detail.cities ?? []);
    const region = vendorList.region?.length === 1 ? vendorList.region[0] : undefined;

    const regionsList = [
        region?.stats?.region_type_voivodeship,
        region?.stats?.region_type_county,
        region?.stats?.region_type_city,
        region?.stats?.region_type_district,
        region?.stats?.region_type_housing_estate,
        region?.stats?.region_type_town
    ].filter(Boolean);

    const locationSlug = useMemo(() => {
        const params = new URLSearchParams(location.search);

        return params.get(LOCATION_PARAM);
    }, [location.search]);

    const cityFromParam = useMemo(() => {
        if (!locationSlug || !cities.length) {
            return null;
        }

        return cities.find((c) => c.slug === locationSlug) ?? null;
    }, [cities, locationSlug]);

    const baseCrumbs = [
        {key: "Deweloperzy", name: "Deweloperzy", position: "2", url: rpAppLink.vendor.list()},
        ...regionsList.map((region, index) => ({
            key: region?.name ?? index,
            name: region?.name ?? "",
            position: (index + 3).toString(),
            url: rpAppLink.vendor.listFriendly({friendlySlug: region?.slug ?? ""})
        })),
        ...(vendor
            ? [
                  {
                      key: vendor.name,
                      name: vendor.name,
                      position: "3",
                      url: rpAppLink.vendor.detail.base({vendorSlug: vendor.slug, vendorId: vendor.id})
                  }
              ]
            : [])
    ];

    const currentPageUrl = `${location.pathname}${location.search ? location.search : ""}`;

    const locationCrumb =
        vendor && cityFromParam
            ? [
                  {
                      key: `lokalizacja-${cityFromParam.slug}`,
                      name: cityFromParam.name,
                      position: (baseCrumbs.length + 1).toString(),
                      url: currentPageUrl
                  }
              ]
            : [];

    return [...baseCrumbs, ...locationCrumb];
};
